import React, { useState } from "react";
import { Tab, Tabs, Typography } from "@mui/material";
import { Box } from "@mui/system";

const VerticalTab = ({ tab = [], handleChange = () => {} }) => {
  const [tabValue, setTabValue] = useState(0);
  const onTabChange = (event, index) => {
    setTabValue(index);
    handleChange(event, index);
  };
  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
    };
  }
  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
        display: "flex",
        height: "100%",
        transition: "0.3s ease-in-out",
      }}
    >
      <Tabs
        orientation="vertical"
        // variant="scrollable"
        // scrollButtons={false}
        value={tabValue}
        onChange={onTabChange}
        sx={{
          borderColor: "divider",
          background: "#DDDDE1",
          borderTopLeftRadius: "12px",
          borderBottomLeftRadius: "12px",
          padding: 1,
          "& .MuiTabs-flexContainer": {
            height: "100%",
            justifyContent: "flex-start",
            transition: "0.3s ease-in-out",
          },
        }}
        TabIndicatorProps={{
          style: {
            display: "none",
          },
        }}
        indicatorColor={"none"}
      >
        {tab?.map((item, index) => {
          return (
            <Tab
              label={
                <Typography
                  sx={{
                    fontWeight: 600,
                    color:
                      index === tabValue
                        ? "red"
                        : item?.disable
                          ? "#2525254D"
                          : "#242424",
                  }}
                >
                  {item?.label}
                </Typography>
              }
              {...a11yProps(index)}
              sx={{
                padding: "0px",
                bgcolor: index === tabValue ? "#FBFBFF" : "inherit",
                borderRadius: "18px",
                minHeight: "38px",
                minWidth: "70px",
              }}
              disableRipple
              disabled={item?.disable}
            />
          );
        })}
      </Tabs>
    </Box>
  );
};

export default VerticalTab;
